import type { OffersTypes } from '../types';

export const getVehicleForPromotions = (offers: OffersTypes) => {
  const { modelName, modelYear, trimName } = offers;

  const vehicleDataFromOffers = {
    modelName,
    modelYear,
    trimName,
  };

  return vehicleDataFromOffers;
};
